import React, { useState, useEffect } from "react";
import { BlackAndWhite } from "../../../../../../themes/Colors";
import { BaseButtons } from "../../../../../../components/atoms";
import { StaffListDisplay } from "./components";
import useWindowDimensions from "../../../../../../components/get-diemensions/UseWindowDiemensions";

const DisacountsDisplay = ({
  auth,
  selectedStore,
  promotionArray,
  promotionCategory,
  staffArray,
  promotionsTotal,
  receiptList,
  dateSelection,
  setReportDisplay,
  reportDisplay,
  discountSearch,
  dateArray,
}) => {
  // dicount display variables for main product spread and fetch

  const { width, height } = useWindowDimensions();

  const [warehouseInventoryList, setWarehouseInventoryList] = useState(null);
  const [warehouseInventoryStockList, setWarehouseInventoryStockList] =
    useState(null);
  const [inventoryStoreList, setStoreInventoryList] = useState(null);

  const [selctedIndex, setSelectedIndex] = useState(0);

  const NameAssemble = ({ product }) => {
    if (product) {
      let name =
        product.productName +
        " | " +
        product.productSubType +
        " | " +
        product.thcType +
        " | " +
        product.thcContent;
      return name;
    }
  };

  // console.log("promotionArray", promotionArray);
  // console.log("promotionCategory", promotionCategory);
  // console.log("staffArray", staffArray);
  // console.log("promotionsTotal", promotionsTotal);
  // console.log("receiptList", receiptList);
  // console.log("dateSelection", dateSelection);

  // totals discount period check per user

  const ReturnPromotionsTotalUsedOverall = () => {
    let stock = 0;

    let promotionArrayNew = [];

    let promotionTotal = [];
    let countTotal = [];

    for (let index = 0; index < promotionArray.length; index++) {
      const element = promotionArray[index];

      promotionTotal.push(Number(element.promotion.discountAmount));
    }

    let promotionsTotalAmountCheck = promotionTotal.reduce(function (x, y) {
      return x + y;
    }, 0);

    return {
      promotionTotal: Number(promotionsTotalAmountCheck).toFixed(2),
      count: promotionTotal.length,
    };
  };

  const ReturnPromotionsCategory = ({ promotionName }) => {
    let stock = 0;

    let promotionArrayNew = [];

    let promotionTotal = [];
    let countTotal = [];
    // console.log("promotionName", promotionName);
    // console.log("staffMemebr", staffMemebr);
    // if (promotionArray) {
    //   promotionArray.map(
    //     (promo) =>
    //       console.log(
    //         "promotionName",
    //         promotionName,
    //         promo.promotion.promotionName
    //       )
    //     // item.promotion.promotionName === promotionName &&
    //     // staffMemebr === item.staffMember
    //     //   ? promotionArrayNew.push(item)
    //     //   : null
    //   );
    // }

    // console.log("promotionArrayNew", promotionArrayNew);
    for (let index = 0; index < promotionArray.length; index++) {
      const element = promotionArray[index];
      if (promotionName === element.promotion.promotionName) {
        promotionTotal.push(Number(element.promotion.discountAmount));
      }
    }

    let promotionsTotalAmountCheck = promotionTotal.reduce(function (x, y) {
      return x + y;
    }, 0);

    return {
      promotionTotal: Number(promotionsTotalAmountCheck).toFixed(2),
      count: promotionTotal.length,
    };
  };

  useEffect(() => {
    if (promotionArray) {
      ReturnPromotionsTotalUsedOverall();
    }
  }, []);

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        height: "100%",
        maxHeight: "100%",
        overflowY: "scroll",
        overflowX: "hidden",
        position: "relative",
      }}
    >
      <div style={{ minHeight: 2 }} />
      <div
        style={{
          width: "100%",
          minHeight: 100,
          marginBottom: 2,
          backgroundColor: BlackAndWhite.secondary,
          display: "flex",
          alignItems: "center",
        }}
      >
        <div style={{ marginLeft: 20 }}>
          <div
            style={{
              padding: 10,
              borderStyle: "solid",
              borderWidth: 1,
              borderColor: "#00000030",
              borderRadius: 4,
              backgroundColor: "#00000020",
            }}
          >
            <div
              style={{
                fontWeight: "bold",
                opacity: 0.7,
                fontSize: 12,
                marginBottom: 5,
              }}
            >
              period
            </div>
            <div>{dateSelection ? dateSelection : "loading"}</div>
          </div>
        </div>
        <div style={{ marginLeft: 20 }}>
          <div
            style={{
              padding: 10,
              borderStyle: "solid",
              borderWidth: 1,
              borderColor: "#00000030",
              borderRadius: 4,

              backgroundColor: "#00000020",
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                fontWeight: "bold",
                opacity: 0.7,
                fontSize: 12,
                marginBottom: 5,
              }}
            >
              Promtions No.
            </div>
            <div>
              {promotionCategory ? promotionCategory.length : "loading"}
            </div>
          </div>
        </div>
        <div style={{ marginLeft: 20 }}>
          <div
            style={{
              padding: 10,
              borderStyle: "solid",
              borderWidth: 1,
              borderColor: "#00000030",
              borderRadius: 4,
              backgroundColor: "#00000020",
            }}
          >
            <div
              style={{
                fontWeight: "bold",
                opacity: 0.7,
                fontSize: 12,
                marginBottom: 5,
              }}
            >
              Total discounted
            </div>
            <div>
              {promotionsTotal
                ? "R " + Number(promotionsTotal).toFixed(2)
                : "loading"}
            </div>
          </div>
        </div>
        <div style={{ marginLeft: 20 }}>
          <div
            style={{
              padding: 10,
              borderStyle: "solid",
              borderWidth: 1,
              borderColor: "#00000030",
              borderRadius: 4,
              backgroundColor: "#00000020",
            }}
          >
            <div
              style={{
                fontWeight: "bold",
                opacity: 0.7,
                fontSize: 12,
                marginBottom: 5,
              }}
            >
              Promotions issued
            </div>
            <div>{promotionArray ? promotionArray.length : "loading"}</div>
          </div>
        </div>
        <div
          style={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            height: "100%",
            overflowX: "scroll",
            overflowY: "hidden",
            maxWidth: width - 300,
          }}
        >
          {promotionCategory
            ? promotionCategory.map((item, index) => {
                return (
                  <div
                    key={index}
                    style={{
                      marginLeft: 20,
                      borderStyle: "solid",
                      borderWidth: 1,
                      borderColor: "#00000030",
                      borderRadius: 4,
                      backgroundColor: "#00000020",

                      minWidth: 150,
                      padding: 10,
                    }}
                  >
                    <div
                      style={{
                        fontWeight: "bold",
                        opacity: 0.7,
                        fontSize: 12,
                        marginBottom: 5,
                      }}
                    >
                      {item.promotionName}
                    </div>
                    <div>
                      {promotionArray
                        ? "R " +
                          ReturnPromotionsCategory({
                            promotionName: item.promotionName,
                          }).promotionTotal
                        : "loading"}
                    </div>
                  </div>
                );
              })
            : "loading"}
        </div>
      </div>
      <div style={{ width: "100%" }}>
        {reportDisplay === "staff"
          ? staffArray
            ? staffArray.map((item, index) => {
                return (
                  <div
                    style={{
                      width: "100%",
                      minHeight: 40,
                      backgroundColor: BlackAndWhite.secondary,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    key={index}
                  >
                    <StaffListDisplay
                      item={item}
                      index={index}
                      selectedIndex={selctedIndex}
                      setSelectedIndex={setSelectedIndex}
                      promotionArray={promotionArray}
                      promotionCategory={promotionCategory}
                      dateSelection={dateSelection}
                      dateArray={dateArray}
                      receiptList={receiptList}
                    />
                  </div>
                );
              })
            : "loading"
          : null}
        {reportDisplay === "categories"
          ? promotionCategory
            ? promotionCategory.map((item, index) => {
                return (
                  <div
                    style={{
                      width: "100%",
                      minHeight: 40,
                      backgroundColor: BlackAndWhite.secondary,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    key={index}
                  >
                    <div
                      style={{
                        width: "98%",
                        borderBottomStyle: "solid",
                        borderBottomWidth: 1,
                        height: 40,
                        display: "flex",
                        alignItems: "center",
                        borderColor: "#00000050",
                      }}
                    >
                      {item.promotionName}
                    </div>
                  </div>
                );
              })
            : "loading"
          : null}
      </div>
    </div>
  );
};

export default DisacountsDisplay;
